

// @ts-nocheck

import Vue from 'vue'

export default Vue.extend({
    props: {
        fieldAddress: Array
    },
    computed: {
    field: {
      get: function (): string | false {
        return this.$store.getters["survey/stepField"](this.fieldAddress);
      },
      set: function (v: string): void {
        this.$store.commit("survey/CHANGE_FIELD", {
          fieldAddress: this.fieldAddress,
          val: v,
        });
      },
    },
    currentContent(): string {
            switch (this.field) {
                case 'singleq':
                    return 'Respondents are allowed to choose only one option as their answer.'                    
                case 'multiq':
                    return 'Respondents are allowed to choose multiple options as their answer.'                                    
                default:
                    return ''
            }            
        }
    }
})

